import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "carousel_pagination-count desktop-body-l"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

import { ICarouselConfig } from '../../types/carousel';
import { ref, toRefs, watch } from 'vue';
import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import CarouselPagination from '.././pagination/CarouselPagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCarousel',
  props: {
    slides: {},
    settings: {},
    previousIconHtml: { default: '' },
    nextIconHtml: { default: '' },
    paginationActive: { type: Boolean, default: false },
    slidesForPagination: { default: 1 },
    navigationActive: { type: Boolean, default: false },
    slidesForNavigation: { default: 1 },
    isNavigationArrowsTogether: { type: Boolean, default: false },
    selectedSlide: { default: 0 },
    showSlidesIndex: { type: Boolean, default: false },
    paginationClass: { default: '' },
    delayInTransition: { default: 0 },
    useDefaultSlideIndexing: { type: Boolean, default: true },
    slideIndexingClasses: { default: 'carousel_pagination-count subtitle-l' }
  },
  emits: ['update:currentSlide'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  slides,
  settings,
  previousIconHtml,
  nextIconHtml,
  paginationActive,
  slidesForPagination,
  navigationActive,
  slidesForNavigation,
  selectedSlide,
  delayInTransition,
  useDefaultSlideIndexing,
  slideIndexingClasses,
} = toRefs(props);

const modelValue = ref(0);
const emit = __emit;
watch(modelValue, (value) => {
  if (value !== selectedSlide.value) {
    emit('update:currentSlide', value);
  }
});
watch(selectedSlide, (value) => {
  if (value !== modelValue.value) {
    if (delayInTransition.value === 0) modelValue.value = selectedSlide.value;
    else {
      setTimeout(() => {
        modelValue.value = selectedSlide.value;
      }, delayInTransition.value);
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Carousel), _mergeProps(_unref(settings), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    class: "static"
  }), {
    addons: _withCtx(({ slidesCount, currentSlide }) => [
      (slidesCount > _unref(slidesForPagination) && _unref(paginationActive))
        ? (_openBlock(), _createBlock(_unref(Pagination), { key: 0 }))
        : _createCommentVNode("", true),
      (
          _unref(navigationActive) &&
          _ctx.isNavigationArrowsTogether &&
          slidesCount > _unref(slidesForNavigation)
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          'carousel__navigation carousel__navigation-static',
          _ctx.paginationClass,
        ])
          }, [
            (_ctx.showSlidesIndex && _unref(useDefaultSlideIndexing))
              ? (_openBlock(), _createBlock(CarouselPagination, {
                  key: 0,
                  classes: _unref(slideIndexingClasses),
                  "slide-index": currentSlide + 1,
                  "total-slides": slidesCount
                }, null, 8, ["classes", "slide-index", "total-slides"]))
              : (_ctx.showSlidesIndex && !_unref(useDefaultSlideIndexing))
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(currentSlide + 1) + " of " + _toDisplayString(slidesCount), 1))
                : _createCommentVNode("", true),
            _createVNode(_unref(Navigation), null, _createSlots({ _: 2 }, [
              (_unref(previousIconHtml))
                ? {
                    name: "prev",
                    fn: _withCtx(() => [
                      _createElementVNode("div", { innerHTML: _unref(previousIconHtml) }, null, 8, _hoisted_2)
                    ]),
                    key: "0"
                  }
                : undefined,
              (_unref(nextIconHtml))
                ? {
                    name: "next",
                    fn: _withCtx(() => [
                      _createElementVNode("div", { innerHTML: _unref(nextIconHtml) }, null, 8, _hoisted_3)
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1024)
          ], 2))
        : (slidesCount > _unref(slidesForNavigation) && _unref(navigationActive))
          ? (_openBlock(), _createBlock(_unref(Navigation), { key: 2 }, _createSlots({ _: 2 }, [
              (_unref(previousIconHtml))
                ? {
                    name: "prev",
                    fn: _withCtx(() => [
                      _createElementVNode("div", { innerHTML: _unref(previousIconHtml) }, null, 8, _hoisted_4)
                    ]),
                    key: "0"
                  }
                : undefined,
              (_unref(nextIconHtml))
                ? {
                    name: "next",
                    fn: _withCtx(() => [
                      _createElementVNode("div", { innerHTML: _unref(nextIconHtml) }, null, 8, _hoisted_5)
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1024))
          : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(slides), (slide, index) => {
        return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {
              item: slide,
              index: index
            })
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 3
  }, 16, ["modelValue"]))
}
}

})